/* import flat from "../../../Assets/Images/questions/questionFive/flat.svg";
import terrace from "../../../Assets/Images/questions/questionFive/terrace.svg";
import semi from "../../../Assets/Images/questions/questionFive/semi.svg";
import detached from "../../../Assets/Images/questions/questionFive/detached.svg";
import bungalow from "../../../Assets/Images/questions/questionFive/bungalow.svg";
 */
export const propertyTypeData = [
  {
    title: "Detached",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171531/AquaHeat/Quote%20Icons/question%205/detached_fgmbny.svg",
  },
  {
    title: "Semi Detached",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171531/AquaHeat/Quote%20Icons/question%205/semi_qbnmah.svg",
  },
  {
    title: "Terrace",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171531/AquaHeat/Quote%20Icons/question%205/terrace_nczlwp.svg",
  },
  {
    title: "Flat",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171531/AquaHeat/Quote%20Icons/question%205/flat_ytku3q.svg",
  },
  {
    title: "Bungalow",
    image:
      "https://res.cloudinary.com/duwmjod0j/image/upload/v1642171531/AquaHeat/Quote%20Icons/question%205/bungalow_o0orjx.svg",
  },
];
